<template>
  <div class="download-center-container">
    <div class="header-box">
      <div class="title">
        <div class="line"></div>
        <div>下载中心</div>
      </div>
    </div>
    <div class="tips-box public-tips-primary">
      虫洞数据处理工具WormHole
      Exporter是客户端虫洞数据导出插件的集合，对主流的BIM建模软件Revit、Bentley、3ds
      Max、Navisworks、Rhino均开发有专用插件，针对*.rvt、*.gim、*.ifc、*.igms、*.fbx、*.3dxml、*.3dm、*.gltf、*.glb、*.stp、*.skp、*.rvm等数据格式开发有集成导出的插件，可方便从这些软件中导出引擎所需的模型数据，包括几何信息、属性信息等。
    </div>
    <div class="plugins-box">
      <div
        class="plugin-item-box"
        v-for="(item, index) in pluginList"
        :key="index">
        <div class="plugin-info-box">
          <div class="image-box">
            <img
              :src="item.iconUrl"
              alt="" />
          </div>
          <div class="summary-box">
            <div class="name-box">{{ item.name }}</div>
            <div class="description-box">{{ item.description }}</div>
          </div>
        </div>
        <div class="link-box">
          <div
            class="link-item-box download-link-box"
            @click="downloadFile(item)">
            下载
          </div>
          <div
            class="link-item-box document-link-box"
            @click="viewPDF(item)">
            文档
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

const firstVersionUrl = 'api/developercenter/Doc/DocItem/first/bydcid'
export default {
  data() {
    return {
      pluginList: [
        {
          name: 'Revit插件',
          // prettier-ignore
          description: "同时支持64位的Revit2016~Revit2024九个版本，支持导出构件几何信息、构件属性信息、材质信息、视图构件关联信息等",
          iconUrl: require('../assets/icon/revit.png'),
          dcId: '3a0b9c77-cdf3-c40e-dc65-8da3728db6b8',
          isStaticRes: false
        },
        {
          name: 'Bentley插件',
          // prettier-ignore
          description: "支持MicroStation CE软件，update12~16，支持导出模型几何信息、构件属性信息、材质信息等",
          iconUrl: require('../assets/icon/bentley.png'),
          dcId: '3a0b9cab-0e03-e2fc-24ca-490cbc031455',
          isStaticRes: false
        },
        {
          name: '3ds Max插件',
          // prettier-ignore
          description: "支持3dsmax2010~3dsmax2023之间的各个简体中文版本，支持导出网格顶点信息和材质信息等",
          iconUrl: require('../assets/icon/3ds-max.png'),
          dcId: '3a0b9cab-5c2f-e967-9dc6-3d5817534d60',
          isStaticRes: false
        },
        {
          name: 'Navisworks插件',
          // prettier-ignore
          description: "同时支持64位的Navisworks Manage 2016~2024九个版本，支持导出构件几何信息、构件属性信息、视图构件关联信息等",
          iconUrl: require('../assets/icon/navisworks.png'),
          dcId: '3a0b9cab-a0cf-7de4-46db-5e5458e6b098',
          isStaticRes: false
        },
        {
          name: '集成插件',
          // prettier-ignore
          description: "支持对rvt，IFC（IFC2x3和IFC4）, fbx, 3dxml, gim, igms, stp, gltf, 3dm, skp, glb, rvm等格式文件进行自动读取和解析",
          iconUrl: require('../assets/icon/cluster-plugin.png'),
          dcId: '3a0b9cac-013a-6a16-c84c-d472f75a06d0',
          isStaticRes: false
        },
        {
          name: 'GIS地形数据转换工具',
          // prettier-ignore
          description: "将地形影像（匹配高程）转换为层次化网格数据，以及将倾斜摄影转换为引擎的zip资源包",
          iconUrl: require('../assets/icon/gis-terrain.png'),
          dcId: '3a0ba2a1-87ca-cff9-75e6-ff00057696de',
          isStaticRes: false
        },
        {
          name: '离线数据查看器',
          // prettier-ignore
          description: "离线数据查看器具备了模型展示、属性查询以及场景切换等多项功能，确保在无网络连接的环境下仍可实现对模型的访问与浏览。",
          iconUrl: require('../assets/icon/offline-view.png'),
          isStaticRes: true,
          // prettier-ignore
          exeDownloadUrl: "/Sources/2025_04_17_17_01_06_3a18969c-870e-6f3a-f9ec-409d04f752be_3a044948-7834-ee8f-1ff8-88260d4f3f59_离线数据查看器_V1.0.1.20250417.exe",
          // prettier-ignore
          pdfDownloadUrl: "/Sources/2025_04_17_17_00_25_3a18969b-e691-750c-2499-9c163770eeb1_3a044948-7834-ee8f-1ff8-88260d4f3f59_离线数据查看器.pdf"
        }
      ]
    }
  },
  mounted() {
    if (window.isStarRiver) {
      const lastIndex = this.pluginList.findIndex(
        item => item.name === '离线数据查看器'
      )
      this.pluginList.splice(lastIndex, 1)
    }
  },
  methods: {
    downloadFile(pluginInfo) {
      if (pluginInfo.isStaticRes) {
        let baseUrl = `${window.developerUrl}/api/developercenter/download`
        let downloadUrl = `${baseUrl}/${pluginInfo.exeDownloadUrl}`
        window.open(downloadUrl)
        return
      }
      let requestUrl = `${window.developerUrl}/${firstVersionUrl}?dcid=${pluginInfo.dcId}`
      axios.get(requestUrl).then(result => {
        if (result.status === 200) {
          let response = result.data
          if (response.isSuccess) {
            let data = response.data
            let accessory = data.accessory
            let downloadUrl = `${window.developerUrl}/api/developercenter/download/${accessory}`
            window.open(downloadUrl)
          } else {
            this.$message.error(response.errMsg)
          }
        }
      })
    },
    viewPDF(pluginInfo) {
      if (pluginInfo.isStaticRes) {
        let baseUrl = `${window.developerUrl}/api/developercenter/download`
        let downloadUrl = `${baseUrl}/${pluginInfo.pdfDownloadUrl}`
        window.open(downloadUrl)
        return
      }
      let requestUrl = `${window.developerUrl}/${firstVersionUrl}?dcid=${pluginInfo.dcId}`
      axios.get(requestUrl).then(result => {
        if (result.status === 200) {
          let response = result.data
          if (response.isSuccess) {
            let data = response.data
            let operationManual = data.operationManual
            let downloadUrl = `${window.developerUrl}/api/developercenter/download/${operationManual}`
            window.open(downloadUrl)
          } else {
            this.$message.error(response.errMsg)
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.download-center-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 16px;
  border-radius: 5px;
  background: var(--page-bgColor);
  box-shadow: var(--base-bg-dark-color30);
  text-align: left;

  .header-box {
    display: flex;
    justify-content: space-between;

    .title {
      display: flex;
      line-height: 32px;
      font-size: 18px;
      font-weight: 500;
      color: var(--page-title-color);
      display: flex;
      align-items: center;

      .line {
        width: 4px;
        height: 24px;
        margin-right: 8px;
        background: var(--base-primary-bgColor);
      }
    }
  }

  .tips-box {
    margin: 16px 0px;
    color: var(--downcenter-text-color);
    font-size: 14px;
    font-weight: 400;
  }

  .plugins-box {
    display: flex;
    flex-wrap: wrap;
    margin-top: 24px;
    overflow-y: auto;
    align-content: flex-start;

    .plugin-item-box {
      position: relative;
      margin-right: 16px;
      margin-bottom: 16px;
      padding: 32px;
      background: var(--downcenter-item-bgColor);
      border: 1px solid var(--downcenter-item-border-color);
      border-radius: 16px;
      cursor: pointer;
      width: calc((100% - 64px) / 4);
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      &:nth-child(4n) {
        margin-right: 0;
      }

      .plugin-info-box {
        display: flex;

        .image-box {
          flex-basis: 84px;
          height: 84px;

          img {
            width: 100%;
            height: 100%;
          }
        }
        .summary-box {
          margin-left: 16px;
          flex: 1;
          .name-box {
            font-size: 14px;
            font-weight: 400;
            color: var(--downcenter-item-title-color);
          }

          .description-box {
            color: var(--downcenter-item-text-color);
            font-size: 12px;
            font-weight: 400;
            margin-top: 8px;
            word-break: break-all;
          }
        }
      }

      .link-box {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-top: 24px;

        .link-item-box {
          width: calc(50% - 4px);
          height: 32px;
          padding: 7px 0px;
          font-size: 12px;
          color: var(--default-color);
          text-align: center;
          text-decoration-line: none;
        }

        .download-link-box {
          background: var(--base-primary-bgColor);
          border-radius: 4px;
          color: var(--aside-bg-color);

          &:hover {
            background: var(--base-bg-light-color40);
            color: var(--aside-bg-color);
          }
        }

        .document-link-box {
          background: var(--base-bg-light-color24);
          color: var(--base-primary-bgColor);
          border-radius: 4px;

          &:hover {
            background-color: var(--base-bg-light-color31);
            color: var(--base-primary-bgColor);
          }
        }
      }
    }
  }
}
</style>
